angular.module('app').filter('memory', function() {
    return function(listing,type,card) {
    	if(!listing) return listing;
        var trace = angular.trace;
    	var results = [];

        for(var i = 0, count = listing.length; i < count; i++){
            var item = listing[i];
            if(type === "match" && item.selected && !item.complete) results.push(item);
            if(type === "complete" && (item.complete || item.distractor)) results.push(item);
        }

    	return results;
    };
});